import buildComponent from './utils/build-component';
import checkIntersection from './utils/check-intersection';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initState: {
    isInView: false,
    imageIsLoaded: false
  },
  initFunction: ($el, params) => {
    const $image = $el.querySelector(`.${nameSpace}__image`)

    //
    // Methods
    //

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (!prevState.isInView && newState.isInView) {
        import(`./block-img-load`).then(module => {
          setTimeout(() => {
            if ($image.src) {
              params.setState({ imageIsLoaded: true })
            } else {
              $image.Component['block-img-load'].addObserver((state) => state.isLoaded && params.setState({ imageIsLoaded: true }));
              $image.Component['block-img-load'].setSrc();
            }
          }, 0)
        })
      }

      if (!prevState.imageIsLoaded && newState.imageIsLoaded) {
        import(`./utils/closest`).then(module => {
          const $slide = module.default({
            el: $image,
            selector: `.${nameSpace}__image-wrapper`,
          });
          $slide.classList.add(`${nameSpace}__image-wrapper--is-loaded`)
        });
      }
    });

    //
    // Procedures
    //

    checkIntersection($el, () => {
      params.setState({ isInView: true });
    });

    //
    // Public API
    //

    return {
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/set-parent-when-loaded.js